import { configuredSanityClient } from '@/lib/sanity/sanityClient';
import groq from 'groq';
import {
  internalLinkProjection,
  MaterializedInternalLink,
  NavItem,
} from '@fagmobler/sanity';

export type TNavigationItem = {
  showInHeader?: boolean;
  title: string;
  _key: string;
  _type: string;
  children?: TNavigationItem[];
  internalLink?: MaterializedInternalLink;
  navType: NavItem['navType'];
  iconUrl?: string;
};

export type TNavigation = {
  mainNavigation: TNavigationItem[];
  footer: TNavigationItem[];
};

const navItemQuery = groq`
  defined(showInHeader) => {showInHeader},
  title,
  _type,
  _key,
  navType,
  showInHeader,
  "iconUrl": icon.asset->.url,
  defined(internalLink) => {
    internalLink {
      ${internalLinkProjection}
    }
  }
`;

export const getNavigation = async (): Promise<TNavigation> => {
  const data = await configuredSanityClient.fetch(
    groq`*[_id == "siteSettings"] {
        mainNavigation[] {
          ${navItemQuery},
          defined(children) => {children[] {
            ${navItemQuery},
            defined(children) => {children[] {
              ${navItemQuery},
              defined(children) => {children[] {
                ${navItemQuery}
              }}
            }}
          }}
        },
        footer[] {
          ${navItemQuery},
          defined(children) => {
            children[] {
              ${navItemQuery}
            }
          }
        }

      }[0]`
  );
  return data as TNavigation;
};
